import {Component, OnInit} from '@angular/core';

import {LocationService} from './location.service';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {AppComponent} from './app.component';
import {Router} from '@angular/router';
import {AuthentificationService} from './authentification.service';
import {WharehousesService} from './warehouses.service';

import {EntrepotService} from './entrepot.service';

@Component({
    selector: 'location-manager',
    templateUrl: './templates/location-manager.component.html',
    styleUrls: ['./styles/location-manager.component.css'],
    providers: [AuthentificationService, EntrepotService, LocationService, WharehousesService]
})
export class LocationManagerComponent implements OnInit {
    name = 'Products Category';

    hide_dialog: boolean = false;
    operation: string = 'CREATION';

    bt_action: string = 'Ajouter';

    showForm: boolean = true;
    location_form: FormGroup;

    places_list: Array<any>;
    parents_list: Array<any>;
    warehouse: any = '';
    warehouses_list: Array<any>;

    location_name: string = '';
    location_reference: string = '';

    location: any = {
        new_location: '',
        new_reference_parent: '',
        new_reference: '',
        reference_old: ''
    };

    defaultValue: string = '';

    constructor(
        private app_component: AppComponent,
        private fb: FormBuilder,
        private authentification_service: AuthentificationService,
        private entrepot_service: EntrepotService,
        private location_service: LocationService,
        private warehouses_service: WharehousesService,
        private router: Router
    ) {
        this.app_component.valTest = '/location-manager';
        this.app_component.GetParent();
    }

    ngOnInit(): void {
        this.createForm();
        this.checkUSerSession();
        this.getWarehouses();
    }

    createForm() {
        this.location_form = this.fb.group({
            name_ctrl: ['', Validators.required],
            parent_ctrl: ['', Validators.required],
            reference_ctrl: ['', Validators.required]
        });
    }

    getLocations() {
        this.location_service.getLocations(this.warehouse)
            .then(result => {
                this.parents_list = result['list'];
                this.location.new_reference_parent = this.parents_list[0].reference;
                this.getParentValue();
            });
    }

    getLocationsTree() {
        this.location_service.getLocationsTree(this.warehouse, this.location_name, this.location_reference)
            .then(result => {
                this.places_list = result['list'];
            });
    }

    getWarehouses() {
        this.entrepot_service.GetEntrepots()
            .then(result => {
                this.warehouses_list = result['list'];
                this.warehouse = this.warehouses_list[0].reference;
                this.getLocations();
                this.getLocationsTree();
            });
    }

    getParentValue() {
        this.defaultValue = this.location.new_reference_parent + '.';
        var reftmp = this.location.new_reference;
        var val_ref = '';
        if (reftmp != null) {
            val_ref = reftmp.substring(reftmp.lastIndexOf('.') + 1);
        }
        this.location.new_reference = this.defaultValue + val_ref;
    }

    checkDefaultValue(): void {
        var oldvalue = this.location.new_reference_parent + '.';
        var reftmp = this.location.new_reference;
        var val_ref = '';
        if (this.location.new_reference.indexOf(oldvalue) === 0) {
            val_ref = reftmp.substring(reftmp.lastIndexOf('.') + 1);
        }
        this.location.new_reference = oldvalue + val_ref;
    }

    insertLocation() {
        this.location_service.insertLocation(this.location, this.warehouse)
            .then(result => {
                this.places_list = result['list'];
                this.parents_list = result['list_parents'];
            });
    }

    editLocation(place: any) {
        if (place.id_location != 1) {
            this.location.id_location = place.id_location;
            this.location.reference_old = place.reference;
            this.location.new_reference = place.reference;
            this.location.new_location = place.location;
            this.location.new_reference_parent = place.reference_parent;
            this.getLocationsForEdition(place.reference);
            this.bt_action = 'Modifier';
            this.operation = 'MODIFICATION';
        }
    }

    updateLocation() {
        this.location_service.updateLocation(this.location, this.warehouse)
            .then(result => {
                this.places_list = result['list'];
                this.parents_list = result['list_parents'];
            });
    }

    getLocationsForEdition(reference: any) {
        this.location_service.getLocationsForEdition(this.warehouse, reference)
            .then(result => {
                this.parents_list = result['parents_list'];
            });
    }

    removeLocation(location: any) {
        if (location.reference_parent != '') {
            this.location.id_location = location.id_location;
            this.location.new_reference = location.reference;
            this.location.new_location = location.location;
            this.hide_dialog = true;
            this.app_component.hide_wrapper(this.hide_dialog);
        }
    }

    dialogCancel(): void {
        this.hide_dialog = false;
        this.app_component.hide_wrapper(this.hide_dialog);
    }

    deleteCategory(): void {
        this.location_service.deleteLocation(this.location)
            .then(result => {
                this.places_list = result['list'];
                this.parents_list = result['list_parents'];
            });
        //        this.products_category_service.GetCategoriesList().then(cat_list => this.cat_list_select = cat_list);
        this.hide_dialog = false;
        this.app_component.hide_wrapper(this.hide_dialog);
        this.reset();
    }

    updateLocations() {
        this.getLocations();
        this.getLocationsTree();
    }

    validateButton(): void {
        if (this.location_form.status === 'VALID') {
            switch (this.bt_action) {
                case 'Ajouter':
                    this.insertLocation();
                    break;
                case 'Modifier':
                    this.updateLocation();
                    break;
            };
            this.reset();
        }
    }

    reset(): void {
        this.location_form.reset();
        this.showForm = false;
        setTimeout(() => {
            this.bt_action = 'Ajouter';
            this.operation = 'CREATION';
            this.createForm();
            this.showForm = true;
        });
        this.updateLocations();
    }

    setStyles(value: any) {
        let styles = {
            'padding-left': value + 'px',
        };
        return styles;
    }

    checkUSerSession(): void {
        this.authentification_service.UserCheckSession()
            .then(result => {
                if (result['id_user'] === 0) {
                    this.router.navigate(['authentification'])
                }
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/location-manager.component.ts